var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"header"},[_c('router-link',{staticClass:"header__title",attrs:{"to":"/"}},[_vm._v(" note todo ")])],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }